import React, {useRef} from 'react';
import {useReactToPrint} from 'react-to-print';
import TicketDesign from './TicketDesign';
import {Button} from '@mui/material';
import WristBandDesign from './WristBandDesign';

export default function PrintTicket({}) {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <div style={{margin: 20}}>
      {/*<TicketDesign ref={componentRef}/>*/}
      <WristBandDesign ref={componentRef}/>
      <Button style={{marginTop: 20}} variant={'contained'} onClick={handlePrint}>Print Ticket</Button>
    </div>
  );
}